import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef
} from '@angular/core';




export class PlannerLayoutComponent implements OnInit {

   itemName: string;
   itemIcon: string;
   sidePanelContent: TemplateRef<any>;
   sectionContent: TemplateRef<any>;

   readonly sidePanelStateChange = new EventEmitter<string>();

  contentHide: Boolean = false;
  sidePanelState: string = 'out';

  constructor() { }

  ngOnInit(): void {
  }

  getCurrentState() {
    return this.sidePanelState;
  }

  toggleSidePanel(): void {
    this.sidePanelState = this.sidePanelState === 'in' ? 'out' : 'in';
    this.sidePanelStateChange.emit(this.sidePanelState);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'alm-planner-layout',
  templateUrl: './planner-layout.component.html',
  styleUrls: ['./planner-layout.component.less'],
  animations:
  [
    trigger('slideInOut', [
      state('in', style({
        width: '50px'

      })),
      state('out', style({
        width: '320px'
      })),
      transition('in <=> out', animate('400ms ease-in-out'))
    ]),
    trigger('slideInOutContent', [
      state('out', style({
        marginLeft: '50px'

      })),
      state('in', style({
        marginLeft: '320px'
      })),
      transition('in <=> out', animate('400ms ease-in-out'))
    ])
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'itemName': [{ type: Input },],
'itemIcon': [{ type: Input },],
'sidePanelContent': [{ type: Input },],
'sectionContent': [{ type: Input },],
'sidePanelStateChange': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
